// HotLeadList.js
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import AdminAppBar from "../adminComponents/AdminAppBar";
import LeadTable from "../Form/LeadTable/LeadTable";
import HotLeadFilter from "./HotLeadFilter";
import CustomHeading from "../common/CustomHeading";
import { ToastContainer } from "react-toastify";
import { getIcons, leadCharacterEmoji } from "../Constant/Constant";

import useHotLeads from "../../hooks/useHotLeads";
import { getBackgroundClass, getStatusBgColor, interestLevel, statusIcons } from "../../Enum/LeadEnumConstants";

const HotLeadList = () => {
  const {
    leads,
    leadDashBoardCount,
    filterVisible,
    setFilterVisible,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    searchQuery,
    setSearchQuery,
    loading,
    currentPage,
    nextPageToken,
    prevPageToken,
    hasMoreLeads,
    countLead,
    setCountLead,
    userRole,
    applyFilter,
    clearFilterData,
    handlePageChange,
    handleSearchLead,
    handleLeadInfo,

    selectedRows,
    setSelectedRows,
    selectedCountLead,
    setSelectedCountLead,

  } = useHotLeads();

  const navigate = useNavigate();
 

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className="text-blue-500 w-[160px] truncate cursor-pointer text-center"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="w-[160px] truncate text-center">
          +{record.countryCode} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return <span className="text-gray-600 text-center w-full">Unknown</span>;

        return (
          <div
            className={`${getStatusBgColor(matchedStatus?.label)} flex items-center justify-center text-center w-44 px-2 gap-2 rounded-full`}
          >
            <img src={matchedStatus.image} alt={matchedStatus.label} className="w-5 h-5" />
            <span className="text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "lastAct",
      title: "Last Act",
      render: (text) => {
        let bgColor = "";
        if (text <= 5) {
          bgColor = "border-[#98DDFF] border bg-blue-100";
        } else if (text <= 10) {
          bgColor = "border-[#FFA64D] border bg-orange-100";
        } else {
          bgColor = "border-[#EE6C4D] border bg-red-100";
        }

        const label = text > 1 ? "days" : "day";
        return (
          <span
            className={`${bgColor} text-gray-600 px-3 py-1 rounded-full flex items-center justify-center w-full`}
          >
            <div className="flex items-center gap-1">
              <div>{text}</div>
              <div>{label}</div>
            </div>
          </span>
        );
      },
    },
    {
      key: "character",
      title: "Character",
      render: (text) => (
        <div className="flex items-center justify-center">
          <img
            className="w-5"
            src={leadCharacterEmoji[text] || leadCharacterEmoji["Not Applicable"]}
            alt={text || "N/A"}
          />
        </div>
      ),
    },
    {
      key: "quality",
      title: "Lead Quality",
      render: (value) => {
        const matchedQuality = interestLevel.find((item) => item.label === value);
        return (
          <div className="flex items-center justify-center gap-2 text-center">
            {matchedQuality?.label && (
              <>
                <img src={matchedQuality.image} alt={matchedQuality.label} className="w-5 h-5" />
                <span className={getBackgroundClass(matchedQuality.label)}>
                  {matchedQuality.label || "Not Quality"}
                </span>
              </>
            )}
          </div>
        );
      },
    },
    {
      key: "location",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0]?.name || "No Location";
        const extraCount = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc.name).join(", ");

        return (
          <span
            className="inline-block cursor-pointer max-w-[170px] truncate whitespace-nowrap overflow-hidden text-center"
            title={fullTitle}
          >
            {firstLocation}
            <span className="text-blue-500">{extraCount}</span>
          </span>
        );
      },
    },
    {
      key: "teamName",
      title: "Team",
      render: (value) => (
        <div title={value} className="w-[100px] truncate cursor-pointer text-center">
          {value}
        </div>
      ),
    },
    {
      key: "userName",
      title: "Assigned To",
      render: (value) => (
        <div title={value} className="w-[100px] truncate cursor-pointer text-center">
          {value}
        </div>
      ),
    },
  ];


  const handleFilterLeads = () => setFilterVisible(true);



  return (
    <div className="pt-24 bg-appGrayBackground">
      <AdminAppBar />
      <div className="px-6">
        <div className="py-6">
          <CustomHeading title={"Hot Leads"} isIcon={true} />
        </div>
        
        <LeadTable
          data={leads}
          hotLead={true}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          
          onSelectionChange={setSelectedRows}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          handleSearchLead={handleSearchLead}
          loading={loading}
          disPlay={false}
          pageSize={countLead}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
      </div>
      <HotLeadFilter
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        selectedCountLead={selectedCountLead}
        setSelectedCountLead={setSelectedCountLead}
        getLocalDate={() => new Date().toISOString().split("T")[0]}
        handleApplyFilter={applyFilter}
        clearFilters={clearFilterData}
      />
      <ToastContainer />
    </div>
  );
};

export default HotLeadList;